// LoginController
app.controller('LoginController', ['$scope', '$location', 'sessionService', 'WdHttpService', 'config', '$window', '$timeout','analyticsService',
    function($scope, $location, sessionService, WdHttpService, config, $window, $timeout, analyticsService) {

        // Init
        $scope.init = async function() {
            await $scope.fetchAdviserSiteDetails();
            $scope.$evalAsync();
            $scope.isHoldingsAnalyse = false;
            if ($location.search().action == 'holdingsAnalyse') {
                //Used by view part
                $scope.holdingsBrokerMap = {}
                $scope.holdingsBrokerList = $scope.getHoldingsEnabledBrokersList();
                $scope.holdingsBrokerList.forEach(broker => {
                    $scope.holdingsBrokerMap[broker] = {};
                    $scope.holdingsBrokerMap[broker]['logoUrl'] = config[broker].logoUrl;
                    $scope.holdingsBrokerMap[broker]['brokerPage'] = config[broker].brokerPage + '?brokerName=' + broker + '&path=' + window.location.origin + '/fund-discovery&returnToken=true';
                    $scope.holdingsBrokerMap[broker]['holdingsPage'] = config[broker].holdingsPage;
                    $scope.holdingsBrokerMap[broker]['brokerName'] = config[broker].brokerName;
                });

                $scope.isHoldingsAnalyse = true;
                config.HOLDINGS_BROKERS.forEach(broker => {
                    $scope.holdingsBrokerMap[broker]['holdingsPage'] = config[broker].holdingsPage + '?action=holdingsAnalyse';
                })
            }
            var wdRefreshToken = $location.search().token;
            if (wdRefreshToken) {
                $scope.showPageLoader();
                sessionService.set('refresh', wdRefreshToken);

                var data = { 'refreshToken': sessionService.get('refresh') }
                await WdHttpService._refresh_token(data, true)
                    .then(async function(response) {
                        $scope.setUserSession(sessionService, response);
                        await WdHttpService._cognito_profile(false)
                            .then(async function(response) {
                                if (response.userStatus === 'CONFIRMED') {
                                    var brokerName = getProfileValueFor('custom:brokerName1', response)
                                    if (!brokerName) {
                                        $('#updateBroker').modal({ backdrop: 'static', keyboard: false });
                                    } else {
                                        sessionService.set("brokerName", brokerName);
                                    }
                                    sessionService.set("investingMode", "REAL");
                                }
                                $scope.handleNormalSignIn(brokerName);
                            });
                    })
                    .catch(function(error) {
                        console.log(error);
                        $scope.hidePageLoader();
                        $scope.showErrorPopup(error);
                    });
            }
            $scope.$evalAsync();
        }

        $scope.submitLoginForm = function() {
            $scope.submitted = true;

            if ($scope.loginForm.$valid) {
                $scope.showLoading('#loginButton');
                if ($scope.username.length == 10 && $scope.username.match('[0-9]{10}')) {
                    $scope.username = '+91' + $scope.username;
                }

                var data = { password: $scope.password, username: $scope.username };
                WdHttpService._log_in(data)
                    .then(async function(response) {
                        var obj = response.data.challengeParameters;
                        if (Object.keys(obj).length === 0) {
                            $scope.setUserSession(sessionService, response);
                            await WdHttpService._cognito_profile(true)
                                .then(async function(response) {
                                    if (response.userStatus === 'CONFIRMED') {
                                        var brokerName = getProfileValueFor('custom:brokerName1', response)
                                        await analyticsService._push_custom_event_data_to_datalayer('user-logged-in', {});
                                                        
                                        if (brokerName) {
                                            sessionService.set("brokerName", brokerName);
                                            // $scope.handleOtherUserStates(response);
                                        }
                                        sessionService.set("investingMode", "REAL");
                                    }   
                                                                 
                                })
                                .catch(error => {
                                    $scope.stopLoading('#loginButton');
                                    $scope.showLoginError(error);
                                });
                        } else {
                            $scope.handleOtherUserStates(response);
                            return;
                        }

                        // Handling redirection according to the queryString and User Type
                        var actionPage = $location.search().action;
                        var path = $location.search().path;
                        var brokerName = getProfileValueFor('custom:brokerName1', sessionService.get('profile'));

                        if (actionPage) {
                            $scope.sendToActionPage(actionPage);
                        } else if (path && path != '/') {
                            $scope.handleRedirectionPath(path);
                        } else {
                            $scope.handleNormalSignIn(brokerName);
                        }

                    }).catch(error => {
                        $scope.stopLoading('#loginButton');
                        $scope.showLoginError(error);
                    });
            } else {
                $scope.showLoginError('Invalid Login attempt, please fill your credentials correctly');
                return false;
            }
        };

        $scope.handleNormalSignIn = async function(brokerName) {
            $scope.stopLoading('#loginButton');
            if (brokerName) {
                if (brokerName != 'WD' && config.BROKERS.indexOf(brokerName) > -1) {
                    $window.location.href = config[brokerName].brokerPage + "?path=/fund-discovery&token=" + sessionService.get('refresh');
                    return;
                }
                $location.path("/fund-discovery").search({});
            } else {
                $('#updateBroker').modal({ backdrop: 'static', keyboard: false });
            }
            // $location.path("/kyc");
        }

        $scope.handleRedirectionPath = function(path) {
            var returnToken = $location.search().returnToken;
            if (returnToken === "true" && $location.absUrl().replace($location.url(), "").includes(location.host)) {
                returnToken = false;
            }
            if (returnToken === "true") {
                var sign = '&';
                if (!path.includes("?"))
                    sign = '?';
                $window.location.href = path + sign + 'token=' + sessionService.get('refresh');
            } else {
                $window.location.href = path;
            }
        }

        $scope.sendToActionPage = async function(actionPage) {
            if (actionPage == 'holdingsAnalyse') {
                await WdHttpService._qc_login().then(response => {
                    $scope.$parent.isQcLoggedIn = true;
                })
                window.location = config.QC_ANALYZER_URL + "/upload-data?&qcAuth=" + btoa(sessionService.get("qcLogin").idToken) + "&wdAuth=" + btoa(sessionService.get("id")) + "&expiresIn=" + btoa(sessionService.get("qcExpiresIn"));
            } else {
                $location.path('/' + actionPage).search({});
            }
        }

        $scope.showLoginError = function(error) {
            if (error.indexOf(" (Service: AWSCognitoIdentityProvider") > 0)
                error = error.substr(0, error.indexOf(" (Service: AWSCognitoIdentityProvider"));
            $scope.$parent.errorLineDisplayFlag = true;
            $scope.$parent.errorMsg = error;
            $scope.errorLineDisplayFlag = true;
            $scope.errorMsg = error;

            $timeout(function() {
                $scope.$parent.errorLineDisplayFlag = false;
                $scope.errorLineDisplayFlag = false;
            }, 6000);
        }

        $scope.handleOtherUserStates = function(response) {
            $scope.stopLoading('#loginButton');
            if (response.data.challengeName == 'NEW_PASSWORD_REQUIRED') {
                sessionService.set('session', response.data.session);
                sessionService.set('username', response.data.challengeParameters.USER_ID_FOR_SRP);
                $location.path('/set-password');
            } else {
                $scope.errorMsg = response.data.challengeName + 'is your current state, please contact admin at admin@wealthdesk.in';
                $scope.errorLineDisplayFlag = true;
            }
        }
    }
]);